module.exports = "/_next/static/images/Cover@2x-20bfcc8e7a399a890e1bdb83ff318b6d.webp";